module.exports = __webpack_public_path__ + "img/downloadImg_22.1c105d98.png";